import { authRoles } from '@/core'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN, MANUFACTURE } = authRoles

const InventoryTransfers = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/index.vue')

const InventoryTransfersDetail = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/detail.vue')

export const inventoryTransfersModuleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/inventory-transfers',
    name: 'inventoryTransfers',
    component: InventoryTransfers,
    meta: {
      title: 'Traspasar material',
      auth: {
        roles: [ADMIN, MANUFACTURE],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
  {
    path: '/inventory-transfers/:id',
    name: 'inventoryTransferDetail',
    component: InventoryTransfersDetail,
    meta: {
      title: 'Traspasar material',
      auth: {
        roles: [ADMIN, MANUFACTURE],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
]
